import {ModalSize, SuiModalService} from '@angular-ex/semantic-ui';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {InternalMessage} from '../../../../core/models/internal-message/internal-message.model';
import {InternalMessagesFilter} from '../../../../core/models/internal-message/internal-messages.filter';
import {InternalMessagesService} from '../../../../core/services/internal-messages/internal-messages.service';
import {ToastService} from '../../../../core/services/toast/toast.service';
import {getSendingDate} from '../../../../core/utils/monday.helper';
import {
  InternalMessageFormModal,
} from '../../../../shared/forms/internal-message-form-modal/internal-message-form-modal.component';
import {
  InternalMessageFormValues,
} from '../../../../shared/forms/internal-message-form-modal/internal-message-form-modal.model';

@Component({
  selector: 'app-manage-internal-messages',
  templateUrl: './manage-internal-messages.component.html',
  styleUrls: ['./manage-internal-messages.component.css'],
  standalone: false,
})
export class ManageInternalMessagesComponent implements OnInit {
  public messages!: InternalMessage[];

  public pagination = {
    collectionSize: 42,
    pageSize: 10,
    selectedPage: 1,
  };

  constructor(
    private modalService: SuiModalService,
    private internalMessagesService: InternalMessagesService,
    private route: ActivatedRoute,
    private toastService: ToastService,
  ) {
  }

  ngOnInit(): void {
    this.loadData();
  }

  private loadData(onlyPageChange?: boolean): void {
    if (!onlyPageChange) {
      this.pagination.selectedPage = 1;
    }

    const params: InternalMessagesFilter = {
      pageSize: this.pagination.pageSize,
      selectedPage: this.pagination.selectedPage,
      institution: 'mine',
    };
    if (this.route.snapshot.data.user) { // this indicates we are in the /author/internalMessages route
      params.createdBy = 'me';
    }

    this.internalMessagesService.getAll(params).subscribe((res) => {
      this.messages = res.docs;
      this.pagination.collectionSize = res.total;
    });
  }

  // updates which messages are shown in the table
  public updateDisplayedMessaged(): void {
    this.loadData(true);
  }

  // Open an internal message form modal to create a message and handle callback
  public openCreateInternalMessageModal(): void {
    this.modalService
      .open(new InternalMessageFormModal({title: $localize`:@@internal-messages-new-message-title:Neue interne Mitteilung`}, ModalSize.Large))
      .onApprove((result: any) => {
        result = result as unknown as InternalMessageFormValues;
        const internalMessage: InternalMessage = {
          readyToSend: true,
          saved: result.saved,
          text: result.text,
          title: result.title,
          extraInfo: result.extraInfo,
        };

        // post created message
        this.internalMessagesService.createOne(internalMessage).subscribe(() => {
          this.loadData();
          this.toastService.success(
            $localize`:@@internal-messages-create-success-title:Interne Mitteilung erstellt`,
            $localize`:@@internal-messages-create-success-message:Die Mitteilung wurde erfolgreich erstellt und für den nächsten Versandtag eingeplant.`,);
        }, error => {
          this.toastService.error(
            $localize`:@@internal-messages-create-error-title:Interne Mitteilung nicht erstellt`,
            $localize`:@@internal-messages-create-error-message:Die Mitteilung konnte nicht erstellt werden.`,
            error);
        });
      });
  }

  public getSendingDate(): Date {
    return getSendingDate();
  }
}
